import { useState } from "react";
import "./PatientDeleteConfirmationModal.css";

import { useAppContext } from "../../../../classes/contexts/AppContext";
import Button from "../../../../components/button/Button";
import WarningIcon from "../../../../components/icons/WarningIcon";
import IconButton from "../../../../components/iconButton/IconButton";
import IconsEnum from "../../../../classes/enums/IconsEnum";
import useTranslation from "../../../../hooks/i18n/useTranslation";
import { deletePatient } from "../../../../services/PatientService";

const PatientDeleteConfirmationModal = ({
  patientData,
  onPatientDeleted = undefined,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { t } = useTranslation();
  const { hidePopup } = useAppContext();

  const handleDeletePatientSubmit = async () => {
    if (isDeleting) return; // Prevent multiple deletion attempts

    setIsDeleting(true);
    try {
      await deletePatient(patientData?._id);

      // If we have a successful response, refresh immediately
      if (onPatientDeleted) {
        onPatientDeleted();
      }

      hidePopup();
    } catch (error) {
      setIsDeleting(false);
    }
  };

  const handleClose = () => {
    if (!isDeleting) {
      hidePopup();
    }
  };

  return (
    <div className="App-module-delete-patient-modal-container">
      <div className="App-module-delete-patient-modal-close">
        <IconButton
          icon={IconsEnum.CLOSE}
          onClick={handleClose}
          noBgColor={true}
          disabled={isDeleting}
          title={t("43")}
        />
      </div>
      <div className="App-module-delete-patient-modal-header">
        <WarningIcon />
        <h2>{t("55")}</h2>
      </div>

      <div className="App-module-delete-patients-modal-body">
        <p className="confirmation-question">
          {t("57")}{" "}
          <strong>
            {patientData
              ? `${patientData.first_name} ${patientData.last_name}`
              : "the patient"}
          </strong>
          ?
        </p>
        <p className="warning-message">{t("56")}</p>
      </div>
      <div className="App-module-delete-patients-actions-container">
        <Button
          value={t("4")}
          disabled={isDeleting}
          onClick={handleDeletePatientSubmit}
          className="delete-button"
        />
      </div>
    </div>
  );
};

export default PatientDeleteConfirmationModal;
